import { FEEDBACK_SUPPLIER_PROFILES, type FeedbackSupplier } from '@erp/rpc';

import { HubbellFeedbackCardView } from './HubbellFeedbackCardView';
import { useHubbellFeedback } from './useHubbellFeedback';

/** A supplier's Feedback card, wired to the org's latest run for it and the API. */
export function HubbellFeedbackCard({
  supplier = 'hubbell',
}: {
  supplier?: FeedbackSupplier;
}) {
  const profile = FEEDBACK_SUPPLIER_PROFILES[supplier];
  const feedback = useHubbellFeedback(profile);
  return (
    <HubbellFeedbackCardView
      supplier={profile}
      run={feedback.run}
      runLoading={feedback.runLoading}
      runError={feedback.runError}
      drop={feedback.drop}
      phase={feedback.phase}
      blocker={feedback.blocker}
      downloadingTab={feedback.downloadingTab}
      onFiles={feedback.addFiles}
      stagedResultsId={feedback.stagedResultsId}
      onToggleNoSalesFile={feedback.toggleNoSalesFile}
      onRemove={feedback.removeFile}
      onStart={feedback.start}
      onDownload={(tab) => void feedback.download(tab)}
    />
  );
}
